import React from "react";
import Particles from "react-particles-js";
import ReactTypingEffect from "react-typing-effect";

//
// .background {

// }

const Home = () => {
  return (
    <section id="home">
      <div className="home-container">
        <div class="background">
          <div class="container">
            <h1>Hey,</h1>
            <br></br>
            <h1>
              I'm <span style={{ color: "#ffbf00" }}>Kartik Gupta</span>
            </h1>
            <h2>
              <span>
                <ReactTypingEffect
                  text={["I travel", "I code", "I write"]}
                  cursorRenderer={(cursor) => <h3>{cursor}</h3>}
                  displayTextRenderer={(text, i) => {
                    return (
                      <h3>
                        {text.split(" ").map((char, i) => {
                          const key = `${i}`;
                          return (
                            <span
                              key={key}
                              style={i % 2 === 0 ? { color: "#1F51FF" } : {}}
                            >
                              {char}
                            </span>
                          );
                        })}
                      </h3>
                    );
                  }}
                />
              </span>
            </h2>
          </div>
        </div>
        <Particles
          params={{
            particles: {
              color: {
                value: ["#fdfdfd", "#1F51FF"],
              },
              line_linked: {
                color: {
                  value: "transparent",
                },
              },
              number: {
                value: window.innerWidth < 700 ? 70 : 150,
              },
              size: {
                value: 2,
              },
            },
          }}
        />
      </div>
    </section>
  );
};

export default Home;
